import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from './Components/Layouts/MainPage/MainPage';
import StartMessagePage from './Components/Pages/StartMessagePage/StartMessagePage';
import ChatMessage from './Components/Pages/Chats/ChatMessage';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import UnAuthorizedPage from './Components/Pages/UnAuthorized/UnAuthorizedPage';
import AuthorizedPage from './Components/Pages/AuthorizedPage/AuthorizedPage';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<PrivateRoute />}>
            <Route path="/" element={<MainPage />}>
              <Route path="/" element={<StartMessagePage />} />
              <Route path="/message/:id" element={<ChatMessage />} />
            </Route>
          </Route>

          <Route path="/authorized/:id" element={<AuthorizedPage />} />
          <Route path="/unauthorized" element={<UnAuthorizedPage />} />
        </Routes>

      </BrowserRouter>


    </>
  );
}

export default App;
